import React, { useState } from "react";
import { toast } from "react-hot-toast";
import api from "../../utils/api";
import "./AccountPage.css";

const PasswordTab = () => {
  const [isSaving, setIsSaving] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const handleChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const toggleVisibility = (field) => {
    setShowPassword({
      ...showPassword,
      [field]: !showPassword[field],
    });
  };

  const isDisabled =
    !passwordData.currentPassword ||
    !passwordData.newPassword ||
    !passwordData.confirmPassword;

  const handleSubmit = async (e) => {
    e.preventDefault();

    // console.log("Form submitted:", passwordData);
    
    // ✅ frontend validation
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (passwordData.newPassword.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    try {
      setIsSaving(true);

      await api.put("/users/change-password", {
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
      });

      toast.success("Password updated successfully");

      // ✅ reset form
      setPasswordData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err) {
      console.error(err);

      toast.error(err?.response?.data?.message || "Failed to update password");
    } finally {
      setIsSaving(false); // ✅ only here
    }
  };

  return (
    <div className="account-profile-card">
      {/* HEADER */}
      <div className="profile-header-column">
        <h3>Password Settings</h3>
        <p className="sub-text">
          Update your password to keep your account secure
        </p>
      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="password-form">
        {/* CURRENT PASSWORD */}
        <div className="form-group password-group">
          <label>Current Password</label>

          <div className="password-input">
            <input
              type={showPassword.current ? "text" : "password"}
              name="currentPassword"
              value={passwordData.currentPassword}
              onChange={handleChange}
              placeholder="Enter current password"
            />
            <span onClick={() => toggleVisibility("current")}>
              {showPassword.current ? "🙈" : "👁"}
            </span>
          </div>
        </div>

        {/* NEW PASSWORD */}
        <div className="form-group password-group">
          <label>New Password</label>

          <div className="password-input">
            <input
              type={showPassword.new ? "text" : "password"}
              name="newPassword"
              value={passwordData.newPassword}
              onChange={handleChange}
              placeholder="Enter new password"
            />
            <span onClick={() => toggleVisibility("new")}>
              {showPassword.new ? "🙈" : "👁"}
            </span>
          </div>
        </div>

        {/* CONFIRM PASSWORD */}
        <div className="form-group password-group">
          <label>Confirm Password</label>

          <div className="password-input">
            <input
              type={showPassword.confirm ? "text" : "password"}
              name="confirmPassword"
              value={passwordData.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm new password"
            />
            <span onClick={() => toggleVisibility("confirm")}>
              {showPassword.confirm ? "🙈" : "👁"}
            </span>
          </div>
        </div>

        <button
          type="submit"
          className="edit-primary-btn"
          disabled={isSaving || isDisabled}
        >
          {isSaving ? <span className="spinner"></span> : "Change Password"}
        </button>
      </form>
    </div>
  );
};

export default PasswordTab;
